module.exports = __webpack_public_path__ + "static/South-East-Corner-Part-Aerial-View-without-legend-Image-3-dd67a1cb72955519896e9810a21a1d9b.jpg";